<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import { SNK } from '@/helpers/helpers'
import { getPokerPositions } from '@/store/gamestate/gamestate'
import { getFullHandSetupOptions } from '@/store/router/router'
import { mttHeroStackTypes } from '@/helpers/constants'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import PokerHistoryEvents from '@/components/Poker/PokerHistoryEvents/PokerHistoryEvents'
import PokerTableStreetFilter from '@/components/PokerTable/PokerTableStreetFilter.vue'

import {
  getAvailableGames,
  getAvailableShortcuts,
  getShortcutsPositions,
  getShortcutsActionOptions,
} from '@/helpers/practice_trainer'

import format_mix from '@/mixins/format_mix'
import screen_mix from '@/mixins/screen_mix'

export default {
  name: 'TrainerStreetFilter',
  components: {
    PokerHistoryEvents,
    CheckboxRow,
    PokerTableStreetFilter,
    Checkbox,
  },
  mixins: [format_mix, screen_mix],
  props: {
    namespace: { String, required: true },
    hasTableName: Boolean,
    // inDialog: Boolean,
    isCentered: { type: Boolean, default: true },
    hasTable: { type: Boolean, default: true },
    hSpotsCentered: { type: Boolean, default: true },
    hasStreetTitle: Boolean,
    hSpotsOpenToTop: { type: Boolean, default: true },
    routerParams: {
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  data() {
    return {
      lastSelectedPlayerKey: 'fh_opponent',
      defaultPlayersSet: false,
      // gmix_hasDepthList: true,
      l_gameformat: '',
      l_customTreeId: '',
      l_solutionType: '',
    }
  },
  created() {
    this.handleGameformatChange(
      this.solElite.want_use
        ? this.solElite?.cTree
          ? 'force-load-tree'
          : false
        : 'force-load-tree',
    )
    this.l_customTreeId = this.customTreeId
    this.l_gameformat = JSON.stringify(this.gameformat)
  },
  methods: {
    getApiAvailableShortcuts() {
      this.$store.dispatch(`${this.namespace}/gmfs_checkForRecomputeBase`, {
        gameformat: this.gameformat,
      })

      this.$store.dispatch('api_poker_available_shortcuts', this.shortcutParams)
    },
    openAdvancedFilter(tab = 'game') {
      const tmpNamespace = 'tmp/primary'
      const dialog = `trainer-advanced-filter-dialog_tab-${tab}_namespace-${this.namespace}_tmpNamespace-${tmpNamespace}`
      this.$store.dispatch('router_set_dialogs', dialog)
    },
    handleGmfChange() {
      this.handleGameformatChange()
    },
    handleGameformatChange(forceLoadTree) {
      const newOne = JSON.stringify(this.gameformat)

      const mainSwitched = !!(this.solElite.want_use
        ? this.l_solutionType === 'gwiz'
        : this.l_solutionType === 'custom')

      const subSwitched = !!(this.solElite.want_use
        ? this.l_customTreeId && this.customTreeId !== this.l_customTreeId
        : this.l_gameformat && newOne !== this.l_gameformat)

      if (mainSwitched || subSwitched) {
        // console.log('reset history')
        this.$store.dispatch(`${this.namespace}/gamestate_reset_history`, {
          namespace: this.namespace,
        })
      }

      // console.log({
      //   forceLoadTree,
      //   solType: this.l_solutionType,
      //   customTreeId: this.customTreeId,
      //   l_customTreeId: this.l_customTreeId,
      //   wantuse: this.solElite.want_use,
      //   mainSwitched,
      //   subSwitched,
      // })

      const noSpots = !this.$store.getters[`${this.namespace}/history_spots`].length

      if (this.solElite.want_use) {
        if (!this.customTreeId) {
          console.log('no custom tree id - reverting to sol.library')
          const query = {
            custree_id: '',
            cussol_id: '',
            solution_type: 'gwiz',
            fh_start_spot: 'preflop',
          }
          this.$store.dispatch(SNK('router_update_query', this.namespace), {
            query,
          })
          this.l_solutionType = 'gwiz'
          return
        }

        if (
          this.startSpot === 'custom_spot' &&
          (forceLoadTree ||
            (noSpots &&
              this.customTreeId === this.l_customTreeId &&
              !this.solElite.loading_what &&
              this.solElite.cTree))
        ) {
          if (forceLoadTree) {
            this.$store.commit(`${this.namespace}/gamestate_set`, {
              key: 'history_spots',
              value: [],
            })
          }

          const query = this.$store.getters[`${this.namespace}/router_query`]
          const hSpotsParams = {
            preflop_actions: query.preflop_actions,
            flop_actions: query.flop_actions,
            turn_actions: query.turn_actions,
            river_actions: query.river_actions,
          }

          this.$store.dispatch(`${this.namespace}/slfrm_getTreePreview`, {
            customTreeId: this.customTreeId,
            hSpotsParams,
          })

          this.l_customTreeId = this.customTreeId
          this.l_solutionType = 'custom'
          return
        }

        if (this.l_customTreeId === this.customTreeId) return
        this.l_customTreeId = this.customTreeId
        this.l_solutionType = 'custom'

        this.$store.dispatch(`${this.namespace}/sol_trainerInitialize`)
        return
      }

      if (this.startSpot === 'custom_spot') {
        if (forceLoadTree || noSpots) {
          this.$store.dispatch('api_poker_history', { namespace: this.namespace })
        }
        this.l_gameformat = newOne
        this.l_solutionType = 'gwiz'
        return
      }

      this.getApiAvailableShortcuts()
      this.l_gameformat = newOne
      this.l_solutionType = 'gwiz'
    },
    setStartSpot(value) {
      if (value === 'custom_spot') {
        this.setAny('fh_hero')
        this.setAny('fh_opponent')
      }
      this.setValue('fh_start_spot', value)
    },
    toggleCheckbox(key, item) {
      // if (!item.hasCheckbox) return
      if (!item.selected.length) {
        this.updateQuery({ [key]: [item.options[0]] || ['on'] })
      } else {
        this.updateQuery({ [key]: [] })
      }
    },
    setSelected(key, item) {
      const values = item.selected
      this.updateQuery({ [key]: values })
    },
    setValue(key, val) {
      this.updateQuery({ [key]: val })
    },
    setAny(key) {
      this.updateQuery({ [key]: '' })
    },
    updateQuery(query) {
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query,
        ...this.routerParams,
      })
    },
    handlePlayerClick(player) {
      if (this.fh.fh_start_spot === 'custom_spot') return

      let key = this.lastSelectedPlayerKey
      if (!player.checked) {
        key = key === 'fh_hero' ? 'fh_opponent' : 'fh_hero'
      }
      this.togglePlayer(key, player.position)
    },
    removePlayers(pos) {
      this.updateQuery({
        fh_hero: this.fh.fh_hero.filter(p => p !== pos),
        fh_opponent: this.fh.fh_opponent.filter(p => p !== pos),
      })
    },
    togglePlayer(key, position) {
      let val = this.fh[key]
      if (val.includes(position)) {
        val = val.filter(i => i !== position)
      } else {
        val = [...val, position]
      }
      this.lastSelectedPlayerKey = key
      this.setValue(key, val)
    },
    getTablePlayerOption(player) {
      const { position } = player
      const options = player.is_folded ? [] : ['hero', 'opponent']

      const sHero = this.fh.fh_hero.includes(position) ? 'hero' : null
      const sOpponent = this.fh.fh_opponent.includes(position) ? 'opponent' : null

      const selected = [sHero, sOpponent].filter(i => i)

      const res = {
        id: position,
        options,
        selected,
      }
      return res
    },
    unavailablePositionsCheck() {
      if (!this.shortcutsLoaded) return
      const { positions } = this.unavailable
      const opponents = this.fh.fh_opponent.filter(p => !positions.includes(p))
      const heros = this.fh.fh_hero.filter(p => !positions.includes(p))
      this.updateQuery({
        fh_hero: heros,
        fh_opponent: opponents,
      })
    },
  },
  computed: {
    flopPreflopGame() {
      return this.fh.fh_start_spot !== 'custom_spot'
    },
    tablePlayersProps() {
      if (this.fh.fh_start_spot === 'custom_spot') {
        return {}
      }
      // if (this.fh.fh_start_spot === 'real_game') {
      //   return {}
      // }
      return { hasCards: false }
    },
    tableHistorySpot() {
      if (this.fh.fh_start_spot === 'custom_spot') {
        return this.history_spot
      }
      return this.preflopFlopHistorySpot
    },
    fullHandSetupOptions() {
      return getFullHandSetupOptions()
    },
    preflopFlopHistorySpot() {
      const streetBoard = this.$store.getters[`${this.namespace}/street_board_any`]('river')
      const res = {
        board: streetBoard.join(''),
        potVisible: true,
        hasPot: true,
        hasStartPot: true,
        useNext: false,
      }
      // console.log(res)
      return res
    },
    history_spot() {
      const history_spot = this.$store.getters[`${this.namespace}/history_spot`]
      const streetBoardAny = this.$store.getters[`${this.namespace}/street_board_any`](
        history_spot?.street,
      )
      const nextStreetBoardAny = this.$store.getters[`${this.namespace}/street_board_any`](
        history_spot?.next_street,
      )
      const useNextPlayer = this.$store.getters[`${this.namespace}/gamestate_player`]
      const useNextPot = this.$store.getters[`${this.namespace}/gamestate_pot`]
      const useNextBoard = this.$store.getters[`${this.namespace}/gamestate_board`]
      const board = streetBoardAny.join('')
      const next_board = nextStreetBoardAny.join('')
      const res = history_spot
        ? {
            ...history_spot,
            board,
            next_board,
            // useNext,

            useNextPlayer,
            useNextPot,
            useNextBoard,
          }
        : null
      // console.log('history_spot--', res)
      return res
    },
    hasHeroStackType() {
      return this.gameformat?.group === 'mtt' && this.gameformat.format !== 'chipev'
    },
    ch_hero_stack_type() {
      const res = {
        id: 'hero_stack_type',
        title: this.$t(`trainer.trainer_hero_stack_type`),
        options: mttHeroStackTypes(),
        selected: this.fh.fh_hero_stack_type,
        title_tooltip: this.$t('trainer.trainer_hero_stack_type_tooltip'),
      }
      return res
    },
    ch_start_spot() {
      const available_shortcuts =
        this.$store.getters.api_get_data('api_poker_available_shortcuts', this.namespace) || []
      // let hasPostflop = available_shortcuts.some(i => i.street === 'FLOP')
      const hasPostflop = !this.shortcutsLoaded
        ? true
        : available_shortcuts.some(i => i.street === 'FLOP')

      // console.log(available_shortcuts)
      const res = {
        id: 'start_spot',
        title: this.$t(`common.select_situation`),
        options: this.usingElite
          ? ['preflop', 'custom_spot']
          : this.fullHandSetupOptions.fh_start_spot,
        selected: this.fh.fh_start_spot ? [this.fh.fh_start_spot] : [],
        disabled: !hasPostflop ? ['flop'] : [],
        title_tooltip: this.usingElite
          ? this.$t('tooltips.start_spot_cssol')
          : this.$t('tooltips.start_spot'),
      }
      return res
    },
    ch_actions() {
      const options = this.shortcutsLoading ? [0, 1, 2, 4, 5] : this.all.actions
      const selected = this.shortcutsLoading ? [0, 1, 2, 4, 5] : this.fh.fh_actions
      const disabled = this.shortcutsLoading ? [] : this.unavailable.actions

      // const cssStyle = options.length > 6 ? '--columns-items-row: repeat(4, 1fr); max-width: 35rem' : ''
      const cssStyle =
        options.length > 7
          ? '--columns-items-row: repeat(auto-fit, minmax(7rem, 1fr)); max-width: 35rem;'
          : ''
      const cssClass = options.length > 7 ? 'cherow_grid' : ''

      const res = {
        id: 'actions_for_shortcut_id',
        title: this.$t('shortcut.street_action', { street: this.$t(`common.preflop`) }),
        // title: this.$t('shortcut.street_action', { street: this.$t(`common.${this.fh.fh_start_spot}`) }),
        options,
        selected,
        disabled,
        cssStyle,
        cssClass,
        hasContent: options.length !== disabled.length,
        title_tooltip: this.$t(`tooltips.${this.fh.fh_start_spot}_action`),
      }
      // console.log('actions', res)
      return res
    },
    ch_hero() {
      const res = {
        id: 'fh_hero',
        title: this.$t('shortcut.hero'),
        options: this.allPokerPositions,
        selected: this.fh.fh_hero,
        title_tooltip: this.$t('tooltips.hero'),
        disabled: this.unavailable.positions,
      }
      return res
    },
    ch_opponent() {
      const res = {
        id: 'fh_opponent',
        title: this.$t('common.gto_opponent'),
        options: this.allPokerPositions,
        selected: this.fh.fh_opponent,
        title_tooltip: this.$t('tooltips.gto_opponent'),
        disabled: this.unavailable.positions,
      }
      return res
    },
    ch_relative_hero() {
      const options = ['IP', 'OOP']
      const res = {
        id: 'fh_rel_positions',
        title: this.$t('shortcut.relative_hero_position'),
        options,
        selected: this.fh.fh_rel_positions,
        title_tooltip: this.$t('tooltips.relative_hero_position'),
      }
      return res
    },
    fh_alternate() {
      const options = ['on']
      const res = {
        id: 'fh_alternate',
        title: this.$t('shortcut.alternate_positions'),
        title_tooltip: this.$t('tooltips.alternate_positions'),

        options,
        anyAsOff: true,
        selected: this.fh.fh_alternate ? this.fh.fh_alternate : [],
      }
      return res
    },
    allPokerPositions() {
      if (this.solElite.want_use) {
        const players = this.solElite.cTree?.players || []
        const res = [
          players.find(p => p.position === 'OOP')?.display_position || 'OOP',
          players.find(p => p.position === 'IP')?.display_position || 'IP',
        ]
        return res
      }
      const { gameformat } = this
      const res = getPokerPositions({ gameformat })
      return res
    },
    all() {
      const apiData =
        this.$store.getters.api_get_data('api_poker_available_shortcuts', this.namespace) || []
      const shortcuts = getAvailableShortcuts({
        shortcuts: apiData,
        start_spot: this.fh.fh_start_spot,
        onlyLabels: true,
      })
      const positions = getShortcutsPositions({ shortcuts })
      const actions = getShortcutsActionOptions({ shortcuts })
      const res = {
        shortcuts,
        actions,
        positions,
      }
      return res
    },
    available() {
      const params = {
        heros: this.fh.fh_hero,
        opponents: this.fh.fh_opponent,
        shortcuts: this.all.shortcuts,
        start_spot: this.fh.fh_start_spot,
      }
      const { shortcuts, actions } = getAvailableGames(params)
      const res = {
        shortcuts,
        actions,
        positions: this.all.positions,
      }
      return res
    },
    unavailable() {
      if (this.solElite.want_use) {
        return {
          actions: [],
          positions: [],
        }
      }
      const positions = this.allPokerPositions.filter(p => !this.available.positions.includes(p))
      const actions = this.all.actions.filter(p => !this.available.actions.includes(p))
      const res = {
        actions,
        positions,
      }
      return res
    },
    tablePlayers() {
      let res = null
      if (this.fh.fh_start_spot === 'custom_spot') {
        const players = (this.history_spot?.players || []).map(i => ({ ...i, hand: '' }))
        res = players
      } else {
        const selectedPositions = [...this.fh.fh_hero, ...this.fh.fh_opponent]

        const style = { '--clr-player-back-folded': 'var(--clr-black-1)' }
        const hoverStyle =
          this.lastSelectedPlayerKey === 'fh_hero'
            ? { '--clr-player-primary': 'var(--clr-opponent)' }
            : { '--clr-player-primary': 'var(--clr-primary)' }

        res = this.allPokerPositions.map(p => {
          let checked = false
          const is_folded =
            this.shortcutsLoading || this.solEliteLoading || this.unavailable.positions.includes(p)
          const asCheckbox = true
          if (this.flopPreflopGame) {
            checked = selectedPositions.includes(p)
          }
          const pos = this.allPokerPositions.includes('BTN') ? 'BTN' : 'SB'
          const is_dealer = p === pos

          const heroChecked = this.fh.fh_hero.includes(p)
          const opponentChecked = this.fh.fh_opponent.includes(p)
          const css_class = is_folded ? 'no-events' : ''
          const r = {
            current_stack: 0,
            chips_on_table: 0,
            position: p,
            asCheckbox,
            is_folded,
            is_active: checked,
            is_dealer,
            heroChecked,
            opponentChecked,
            css_class,
            is_bot: this.fh.fh_opponent.includes(p),
            style: this.fh.fh_opponent.includes(p)
              ? { ...style, '--clr-player-primary': 'var(--clr-opponent)' }
              : checked
                ? style
                : hoverStyle,
          }
          return r
        })
      }
      // console.log(res)
      return res
    },
    fh() {
      const qqfh = this.$store.getters[`${this.namespace}/query_fullhand_setup`]
      const fh = {}
      Object.keys(qqfh).forEach(key => {
        fh[key] = qqfh[key].split(',').filter(i => i)
      })
      const res = {
        fh_start_spot: qqfh.fh_start_spot,
        fh_hero: fh.fh_hero,
        fh_hero_stack_type: fh.fh_hero_stack_type,
        fh_opponent: fh.fh_opponent,
        fh_actions: fh.fh_actions,
        fh_alternate: fh.fh_alternate,
        fh_rel_positions: fh.fh_rel_positions,

        fh_rng: fh.fh_rng.length ? fh.fh_rng.join('') : false,
        fh_trainer_session: fh.fh_trainer_session.length ? fh.fh_trainer_session.join('') : false,
        fh_trainer_tables: this.mobile
          ? false
          : fh.fh_trainer_tables.length && Number(fh.fh_trainer_tables[0]) > 1
            ? fh.fh_trainer_tables.join('')
            : false,
        fh_trainer_learning_mode: fh.fh_trainer_learning_mode.length
          ? fh.fh_trainer_learning_mode.join('')
          : false,
        fh_trainer_timebank: fh.fh_trainer_timebank.length
          ? fh.fh_trainer_timebank.join('')
          : false,
      }
      // console.log(res)
      return res
    },
    gameformat() {
      let res = null
      if (this.fh.fh_start_spot === 'custom_spot') {
        res = this.$store.getters[`${this.namespace}/gameformat`]
      } else {
        res = this.gmfWithMostPlayers
        if (!res) {
          console.log('no multiple gameformat')
          res = this.$store.getters[`${this.namespace}/gameformat`]
        }
      }
      // console.log(res)
      return res
    },
    query_gameformat() {
      return this.$store.getters[`${this.namespace}/query_gameformat`]
    },
    gmfWithMostPlayers() {
      return this.$store.getters[`${this.namespace}/gmfs_gmfWithMostPlayers`]
    },
    startSpot() {
      return this.fh.fh_start_spot
    },
    allSelectedPositions() {
      return [...this.fh.fh_hero, ...this.fh.fh_opponent]
    },
    api_poker_available_shortcuts() {
      const res = this.$store.getters.api_get('api_poker_available_shortcuts', this.namespace)
      return res
    },
    shortcutsLoading() {
      return this.api_poker_available_shortcuts?.loading
    },
    shortcutsLoaded() {
      return this.api_poker_available_shortcuts?.loaded
    },

    solElite() {
      return this.$store.getters[`${this.namespace}/sol_elite`]
    },
    usingElite() {
      const res =
        this.solElite.want_use &&
        (this.solElite.custom_solution_tree?.loading ? true : !this.solElite.must_create)
      return res
    },
    customTreeId() {
      return this.solElite.custom_tree_loaded
        ? this.solElite.custom_tree_id
        : this.$store.getters[`${this.namespace}/query_custree_id`]
    },
    solEliteLoading() {
      return (
        !!this.solElite.loading_what ||
        this.$store.getters.api_get('api_poker_custom_user_trees').loading
      )
    },

    hSpotsLoading() {
      const skeleton =
        !this.$store.getters[`${this.namespace}/history_spots`].length ||
        !!(this.solElite?.want_use && this.solElite.loading_what)
      const spinner = !skeleton && this.$store.getters.api_get(`api_poker_tree_preview`).loading
      const res = {
        ...(skeleton ? { skeleton } : {}),
        ...(spinner ? { spinner } : {}),
      }
      return res
    },
    globals_action() {
      return this.$store.getters.globals_action
    },
    shortcutParams() {
      const { depthRow, stacksRow, avgStackRow } =
        this.$store.getters[`${this.namespace}/gmfs_tableConf`]
      const res = {
        namespace: this.namespace,
        // gameformat: this.gameformat,
        query_gameformat: this.query_gameformat,
        tableRows: this.$store.getters[`${this.namespace}/gmfs_tableRows`],
        hasDepthList: depthRow,
        hasStacksList: stacksRow,
        hasAverageStack: avgStackRow,
      }
      return res
    },
  },
  watch: {
    globals_action(a) {
      if (a === 'trainer_drill_changed') {
        this.l_gameformat = ''
        this.l_customTreeId = ''
        this.l_solutionType = ''
        this.$store.dispatch('globals_action', '')
      }
    },
    solElite() {
      this.handleGmfChange()
    },
    shortcutsParams() {
      this.handleGmfChange()
    },
    gameformat() {
      this.handleGmfChange()
    },
    startSpot() {
      this.handleGmfChange()
    },
    shortcutsLoaded() {
      this.unavailablePositionsCheck()
    },
  },
}
</script>

<template>
  <div
    class="trainer-settings trasett"
    :class="{ trasett_centered: isCentered }"
  >
    <PokerTableStreetFilter
      v-if="hasTable"
      :style="`
      --margin-horizontal: 0 auto;
      --table-hor-min-height: 20em;
      --table-hor-max-width: 48em;
      --table-ver-max-width: 32rem;
      --table-ver-min-height: 39rem;
      --table-ver-max-height: 44rem;
      --cards-space:2.5em;
      flex:0;
      `"
      tour="tra_configuretable"
      class="text-noselect trasett_poker-table"
      :namespace
      :gameformat
      :players="tablePlayers"
      :spot="tableHistorySpot"
      :playerHasStack="fh.fh_start_spot === 'custom_spot'"
      :playersProps="tablePlayersProps"
      @click:player="handlePlayerClick"
    >
      <template
        v-for="player in flopPreflopGame ? tablePlayers : []"
        #[`${player.position}_before`]
        :key="`${player.position}_before`"
      >
        <div
          v-if="player.heroChecked"
          class="tratablstreet_icon tratablstreet_icon_hero anim-flip-in uppercase weight_700"
          style="--clr: var(--clr-hero)"
        >
          {{ $t('common.hero') }}
        </div>
        <div
          v-if="player.opponentChecked"
          class="tratablstreet_icon tratablstreet_icon_bot anim-flip-in weight_700 table"
          style="--clr: var(--clr-opponent)"
        >
          {{ $t('common.gto') }}
        </div>

        <div
          v-show="!player.is_folded && !mobile"
          class="player_content_before player_content_before_back player_content-hover"
        >
          <div class="trasett_player_check">
            <Checkbox
              class="trasett_player_check_item"
              style="
                --clr-back: var(--clr-black-1-3);
                --clr-back-hover: var(--clr-hero);
                --clr-back-active: var(--clr-hero);
                --padding: 0.35rem 0.75rem;
              "
              :value="fh.fh_hero.includes(player.position)"
              :asBtn="true"
              @click="togglePlayer('fh_hero', player.position)"
            >
              {{ $t(`common.hero`) }}
            </Checkbox>
            <Checkbox
              class="trasett_player_check_item"
              style="
                --clr-back: var(--clr-black-1-3);
                --clr-back-hover: var(--clr-opponent);
                --clr-back-active: var(--clr-opponent);
                --padding: 0.35rem 0.75rem;
              "
              :value="fh.fh_opponent.includes(player.position)"
              :asBtn="true"
              @click="togglePlayer('fh_opponent', player.position)"
            >
              {{ $t(`common.gto`) }}
            </Checkbox>
            <div
              v-if="
                fh.fh_hero.includes(player.position) || fh.fh_opponent.includes(player.position)
              "
              class="icon_btn mdi mdi-close pa-1 clr-grey anim-fade-in csst"
              style="
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: calc(var(--right-x) - 0.5rem);
                left: calc(var(--left-x) - 0.5rem);
                z-index: 4;
              "
              @click="removePlayers(player.position)"
            >
              <div
                class="csst_content clr-white"
                style="top: -1.75rem"
              >
                {{ $t('btn.clear') }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <div style="min-height"></div>
    </PokerTableStreetFilter>

    <div class="trasett_main-options">
      <slot name="main_before"> </slot>
      <CheckboxRow
        class="trasett_checkbox-row"
        tour="tra_startspots"
        :item="ch_start_spot"
        :checkboxAs="'btn'"
        style="--clr-row-back: var(--clr-black-1-2)"
        :style="isCentered ? '--title-size: 1rem;--title-margin:0 0 0.25rem 0' : ''"
        :titleClass="
          isCentered ? 'f-center ee weight_500 text-normal clr-grey uppercases mb-1s  mt-4s' : ''
        "
        :contentClass="isCentered ? 'f-center ee' : ''"
        :styleCheckbox="isCentered ? '--padding: 0.625rem 0.75rem;' : ''"
        :hasAny="false"
        :isSingle="true"
        @update="item => setSelected('fh_start_spot', item)"
      >
        <template #default="v">
          {{
            solElite.want_use
              ? $t(`common.${v.id === 'preflop' ? 'from_start' : v.id}`)
              : $t(`common.${v.id}`)
          }}
        </template>
      </CheckboxRow>

      <CheckboxRow
        v-if="!usingElite && (fh.fh_start_spot === 'flop' || fh.fh_start_spot === 'preflop')"
        class="trasett_checkbox-row"
        tour="tra_actions"
        :class="ch_actions.cssClass || ''"
        :style="`
              ${ch_actions.cssStyle || ''}
              ${isCentered ? '--title-size: 1rem;--title-margin:0 0 0.25rem 0' : ''}
        `"
        :titleClass="
          isCentered ? 'f-center ee weight_500 text-normal clr-grey uppercases mb-1s  mt-4s' : ''
        "
        :styleCheckbox="isCentered ? '--padding: 0.625rem 0.75rem;' : ''"
        :contentClass="isCentered ? 'f-center ee' : ''"
        :hasTitle="true"
        :hasAny="true"
        :hasContent="ch_actions.hasContent"
        :item="ch_actions"
        :loading="shortcutsLoading"
        @update="item => setSelected('fh_actions', item)"
      >
        <template #default="v">
          {{ shortcutsLoading ? '' : $t(`shortcut.${v.id}`) }}
        </template>
        <template #after>
          <div
            v-if="!ch_actions.hasContent"
            class="text-center px-2 py-1 clr-yellow b-radius_4 f-center"
            style="background-color: rgba(255, 184, 0, 0.1)"
          >
            <i class="mdi mdi-information-outline mr-2"></i>
            {{ $t(`messages.solution_no_shortcuts_trainer`) }}
          </div>
        </template>
      </CheckboxRow>

      <PokerHistoryEvents
        v-if="fh.fh_start_spot === 'custom_spot'"
        ref="hSpots"
        :namespace="namespace"
        :useTreePreview="usingElite"
        :customTreeId="customTreeId"
        :customLoading="hSpotsLoading"
        :hasFlopSolutionEndNode="!usingElite"
        :canAISolve="false"
        :clickableFlopSolutionEndNode="false"
        :hasWatcherEnabled="false"
        :hasMinimized="false"
        :hasTurnPreload="false"
        :hasTmpBoard="false"
        :hasInitialLoad="false"
        :hasShortcuts="true"
        :hasFilter="true"
        :hiddenShortcutBtns="[usingElite ? 'shortcut' : '', 'save_spot', 'practice_spot', 'expand']"
        :openToTop="hSpotsOpenToTop"
        dialog="practice-filter-dialog"
        :innerCssClass="'pl-1 pr-2'"
        class="w-100 mt-4 trasett_hs-spots"
        style="
          --clr-hs-back: var(--clr-black-2);
          --hs-spot-clr-border: var(--clr-black-3);
          --hs-spot-margin: 0 0.25rem 0 0;
          --hs-grid-gap: 0.25rem;
          --clr-hero: var(--clr-hero-default);
        "
      />

      <CheckboxRow
        v-if="!usingElite && !hasTable && fh.fh_start_spot !== 'custom_spot'"
        class="trasett_checkbox-row"
        :item="ch_hero"
        :checkboxAs="'btn'"
        :titleClass="isCentered ? 'f-center' : ''"
        :contentClass="isCentered ? 'f-center' : ''"
        :loading="shortcutsLoading"
        @update="item => setSelected('fh_hero', item)"
      >
        <template #default="v">
          <span v-html="getPlayerHtmlPosition(v.id)"></span>
        </template>
      </CheckboxRow>

      <slot name="main_after"> </slot>
    </div>

    <CheckboxRow
      v-if="!usingElite && !hasTable && hasHeroStackType"
      class="trasett_checkbox-row"
      :item="ch_hero_stack_type"
      :checkboxAs="'btn'"
      :titleClass="isCentered ? 'f-center' : ''"
      :contentClass="isCentered ? 'f-center' : ''"
      :loading="shortcutsLoading"
      @update="item => setSelected('fh_hero_stack_type', item)"
    >
      <template #default="v">
        <span v-html="shortcutsLoading ? '' : $t(`trainer.trainer_hero_stack_type_${v.id}`)"></span>
      </template>
    </CheckboxRow>

    <CheckboxRow
      v-if="!usingElite && !hasTable && fh.fh_start_spot !== 'custom_spot'"
      class="trasett_checkbox-row"
      :item="ch_opponent"
      :checkboxAs="'btn'"
      :styleCheckbox="'--clr-enabled:var(--clr-opponent)'"
      :titleClass="isCentered ? 'f-center' : ''"
      :contentClass="isCentered ? 'f-center' : ''"
      :loading="shortcutsLoading"
      @update="item => setSelected('fh_opponent', item)"
    >
      <template #default="v">
        <span v-html="getPlayerHtmlPosition(v.id)"> </span>
      </template>
    </CheckboxRow>

    <CheckboxRow
      v-if="!hasTable && fh.fh_start_spot !== 'custom_spot'"
      class="trasett_checkbox-row"
      :item="ch_relative_hero"
      :checkboxAs="'btn'"
      :titleClass="isCentered ? 'f-center' : ''"
      :contentClass="isCentered ? 'f-center' : ''"
      :isSingle="true"
      @update="item => setSelected('fh_rel_positions', item)"
    >
      <template #default="v">
        <span v-html="getPlayerHtmlPosition(v.id)"> </span>
      </template>
    </CheckboxRow>

    <CheckboxRow
      v-if="!hasTable && fh.fh_start_spot !== 'custom_spot'"
      class="trasett_checkbox-row"
      :item="fh_alternate"
      :checkboxAs="'btn'"
      :titleClass="isCentered ? 'f-center' : ''"
      :contentClass="isCentered ? 'f-center' : ''"
      :isSingle="true"
      @update="item => setSelected('fh_alternate', item)"
    >
      <template #default="v">
        {{ $t(`btn.${v.id}`) }}
      </template>
    </CheckboxRow>
  </div>
</template>

<style lang="scss" scoped>
.trasett {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 56rem;
  gap: 1rem;
  &_centered {
    border-radius: 8px;
    padding: 2.5rem 1rem;
    .trasett_main-options {
      padding: 1rem 0;
      align-items: center;
    }
  }
  &_main-options {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  &_player_checkbox_row {
    position: relative;
  }
  &_player_check {
    display: flex;
    flex-direction: column;
    grid-gap: 0.25rem;
    padding: 0 1rem 0 1rem;
    &_item {
      font-weight: 500;
    }
  }
  &_modes-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 1rem auto 0 auto;
    padding: 0.25rem 1rem;
    font-weight: 500;
    grid-column-gap: 1rem;
    grid-row-gap: 0rem;
    max-width: calc(100vw - 2rem);
    color: var(--clr-grey-2);
    border-radius: 4px;
    background: var(--clr-black-1);
    cursor: pointer;
    &:hover {
      background: var(--clr-black-1-3);
    }
    &_title {
      font-weight: 700;
    }
  }
}

.tratablstreet {
  &_icon {
    position: absolute;
    z-index: 1;
    background: var(--clr);
    font-size: 0.8rem;
    color: va(--clr-white-0);
    border-radius: 4px;
    line-height: 1.1;
    padding: 0.125rem 0.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &_hero,
    &_bot {
      font-size: 0.8em;
      text-shadow: var(--text-shadow_drop);
    }
    &_hero {
      bottom: 80%;
    }
    &_bot {
      top: 80%;
    }
  }
}

@media (max-width: 1400px) and (min-width: 1024px) {
  .trasett {
    &_poker-table {
      min-width: 42em !important;
      min-height: 20em !important;
    }
  }
}

@media (max-width: 1023px) {
  .trasett {
    max-width: 100vw;
    padding: 2rem 0;
    &_checkbox-row {
      padding: var(--mobile-row-padding);
    }
  }
}
</style>
